import { Html, Head, Main, NextScript } from 'next/document'

export default function Document() {
  return (
    <Html lang="es">
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@200;300;400,500&family=Inter:wght@300;400;500&display=swap" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap" rel="stylesheet" />
        
        {/* Script to clean up browser extension attributes before React hydration */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function() {
                // Remove data attributes added by Grammarly and other extensions
                const cleanAttributes = ['data-new-gr-c-s-check-loaded', 'data-gr-ext-installed', 'data-gr-c-s-loaded', 'data-react-helmet'];
                cleanAttributes.forEach(attr => {
                  document.querySelectorAll('[' + attr + ']').forEach(el => el.removeAttribute(attr));
                });
                
                // Remove elements added by extensions (like Grammarly popups)
                const extensionClasses = ['gr-textarea-btn', 'gr-popup', 'grammarly-desktop-integration'];
                extensionClasses.forEach(cls => {
                  document.querySelectorAll('.' + cls).forEach(el => el.remove());
                });
              })();
            `,
          }}
        />
      </Head>
      <body>
        <Main />
        <NextScript />
      </body>
    </Html>
  )
}
